
import Component from "vue-class-component";
import { Vue } from "vue-property-decorator";
import OpenLocker from "@/components/admin/sav/OpenLocker.vue";
import SimulateCodeUse from "@/components/admin/sav/SimulateCodeUse.vue";

@Component({
  components: { SimulateCodeUse, OpenLocker },
})
export default class Sav extends Vue {
  //
}
